import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-externalauth',
  templateUrl: './externalauth.component.html',
  styleUrls: ['./externalauth.component.css']
})
export class ExternalauthComponent implements OnInit {
  islecturer: any;
  constructor(private activatedroute: ActivatedRoute, private userservice: UseraccessserviceService, private router: Router, private toastr: ToastrService, private util: UtilService
  ) { }

  async ngOnInit() {
    // NOTE: this is the landing page for the external API integration —
    // users/authcreateprivateschoolstudent returns { jwt } and the partner system
    // redirects the student here. The query parameter is a live integration contract,
    // so it cannot simply be dropped. See docs/refactor/M01-findings.md (A6).
    const jwt = this.activatedroute.snapshot.queryParams.jwt;
    if (!jwt) {
      this.toastr.error("This sign-in link is missing its credentials. Please request a new one.");
      this.router.navigate(['/access/login'], { replaceUrl: true });
      return;
    }
    this.userservice.setAuthenticatedUserToken(jwt);
    this.islecturer = this.activatedroute.snapshot.queryParams.lecturer;
    try{
      await this.util.logactivity(
        {
          "ActivityType": 1,
          "ModuleId": 0,
          "ClassId": 0,
          "AssessmentId": 0,
        }        
      ).toPromise();
    }
    catch (e){
      console.log(e);
      this.toastr.warning(e)
    }
    // replaceUrl so the token does not stay in browser history as a reusable credential
    if (this.islecturer === "true") {
      this.router.navigate(['/user/usermodules'], { replaceUrl: true });
    }
    else
      this.router.navigate(['/'], { replaceUrl: true });
  }

}
